const randomQuizPlaceholder = () => {
  const placeholders = ['Try “Icebreaker about movies”', 'Try “Earth is the third planet from the Sun at a distance of about 93 million miles.”', 'Try “Marketing”', 'Try “Questions for team retrospective”']
  const index = Math.floor(Math.random() * placeholders.length)
  return placeholders[index]
}

export default {
  randomQuizPlaceholder,
}
